<template>
	<main>
		<HeaderTab
			:title="$t('client_area.contract_options')"
			:swiper_tabs="swiper_tabs"
		/>

		<div id="content">
			<router-view></router-view>
		</div>
	</main>
</template>

<script type="text/javascript">
	export default {
		name: "ContractOptionsClientArea",
		computed: {
			swiper_tabs() {
				return [
					{
						label: 'menu.client_area.settings.contract_commercialization',
						href: 'contractCommercializationCa',
						active: true
					},
					{
						label: 'menu.client_area.settings.messages_customization',
						href: 'contractMessagesCustomizationCa',
						active: false
					},
				]
			}
		},
		components: {
			HeaderTab: () => import('@/components/HeaderTab')
		}
	}
</script>
